import { Ba1300Class } from "../ba1300/ba1300-class";
import { FileAttachmentClass } from '../common/file-attachment/file-attachment-class';
import { Tsk5010Class } from "../../Class/TSK5010/tsk5010-class";
import { Adm0006Class } from "../ADM0006/adm0006-class";


export class Tsk5020Class {

    EmployeeList: Array<Ba1300Class> = [];
    TaskId : number
    TaskNumber : number
    TaskStatus : number
    FkFieldIdTaskRole: string;
    TaskCaption: string;
    TaskDetailedDescription: string;
    FkEmpId :number
    Priority:number
    AssignedonDate: Date;
    TargetDate: Date;
    FkTaskGroupId : number
    FkTaskProjectId : number
    tsk5020History: Tsk5020Class;
    AssignedtoEmployeeSelected :Number;
    FkEmpIdAssignedTo:number
    Taskcategory:string;
    Project:string;
    MdfdBy: number;
    MdfdOn: Date;

    TaskDetailsId : number
    FkTaskId : number
    CategoryId : number
    CurrentDate : Date
    Duration : String
    Comments : String
    FkUserId : number
    CommentedAuthority : number 

    PageName:string;
    TableName:string;
    AutoId:number;
    AttachmentList:  Array<FileAttachmentClass> = [];

    viewclosed: number;

    LoadCardlist : Array<Tsk5020Class> = []; 
    LoadDatalist : Array<Tsk5020Class> = []; 

    FkDateFrm : Date;
FkDateTo : Date;
CmpDateFrm : Date;
CmpDateTo : Date;
TskDateFrm:Date;
TskDateTo:Date;
TaskroleReportlist: Array<Tsk5010Class> = [];
TaskStatusReportlist: Array<Tsk5010Class> = [];
AssignedByEmployeeList:Array<Ba1300Class> = [];
AssignedToEmployeeList:Array<Ba1300Class> = [];
ProjectReportList: Array<Tsk5010Class> = [];
TaskCategoryReportList: Array<Tsk5010Class> = [];
FkCompId: number;
CrtdBy: number;
CompNam: string;
UserNam: string;
LoadFilterData : Array<Tsk5020Class> = []; 



FkCompIdAssignedTo:number;

ParamTaskRoleSelected:  Array<Adm0006Class> = [];
ParamTaskStatusSelected:  Array<Adm0006Class> = [];
ParamAssignedByEmployeeSelected:  Array<Ba1300Class> = [];
ParamAssignedToEmployeeSelected:  Array<Ba1300Class> = [];
ParamATaskSelected:  Array<Tsk5010Class> = [];
ParamProjectSelected:  Array<Tsk5010Class> = [];


Tsk5020List: Array<Tsk5020Class> = [];
 
     ChecklistDtlsId:number;
     ChecklistName:string;
     ChecklistDate:Date;
     ChecklistComment:string;



}
